import { REACT_APP_API_URL_REPORT } from "constants/index";

import { useReportDistributionControllerGetReportDistributionDetail } from "generated/rm";
import { useNotification } from "hooks/useNotification";
import { useParams } from "react-router-dom";

import { ReportDistributionDetailForm } from "./ReportDistributionDetailForm";

const ReportDistributionDetail = () => {
  const { id } = useParams();

  const { data, isLoading, error } =
    // eslint-disable-next-line
    useReportDistributionControllerGetReportDistributionDetail(
      {
        id,
      },
      {
        axios: {
          baseURL: REACT_APP_API_URL_REPORT,
        },
      }
    );
  useNotification(error);
  return data ? (
    <ReportDistributionDetailForm
      data={data?.data?.reportDistributionDetails}
      expiredAt={data?.data?.expiredAt}
      allowDownload={false}
    />
  ) : null;
};

export default ReportDistributionDetail;
